import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Attachments_delete extends PureComponent {
  render() {
    return (
      <div className="row" id="attachments_delete">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Attachment Delete</h2>
              <p>
                The delete attachment function allows you to delete a file
                attached to a record. The delete attachment function only
                accepts an array of file keys. File keys can be acquired through
                the search attachments function.{" "}
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Attachment Delete Example</h2>
              <p>
                Once a file is uploaded you can rename it. Not that renaming a
                file only changes the name it will display and download as. The
                S3 key permanent will remain the same.
              </p>
              <p>Request:</p>
              <div className="darkCode">
                <span className="methodCodeDELETE">DELETE</span> - https://
                <span className="jsonY">example</span>.api.nexoid.com/v1/record/
                <span className="jsonY">object_type</span>/
                <span className="jsonY">454</span>/attachment/delete
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"session_id"</span>:{" "}
                  <span className="jsonY">
                    "
                    <span className="jsonO">
                      &#123;&#123;session_id&#125;&#125;
                    </span>
                    "
                  </span>
                  ,
                </div>
                <div className="i1">
                  <span className="jsonG">"keys"</span>: [{" "}
                  <span className="jsonY">
                    "8t33mumxa0lnxc4x/screenshot.png"
                  </span>{" "}
                  ]
                </div>
                <div>&#125;</div>
              </div>
              <p>Response:</p>
              <div className="darkCode">
                <div>
                  Code: <span className="statusCode">200</span>
                </div>
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123; &#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Attachments_delete;



// WEBPACK FOOTER //
// ./src/components/knowlege/api/Attachments_delete.js